(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["performance-cart-complements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('performance-cart-complements')) {
    customElements.define('performance-cart-complements', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.load();
      }
      async load() {
        const result = this.querySelector('.performance-complements-results');
        if (!result) return;
        const list = result.querySelector('ul');
        const seen = new Set((this.dataset.exclude || '').split(','));
        const sources = [...new Set((this.dataset.products || '').split(','))].filter(id => /^\d+$/.test(id));
        for (const id of sources) {
          if (list.children.length >= 3 || !this.isConnected) break;
          try {
            const url = new URL(this.dataset.route, window.location.origin);
            url.search = new URLSearchParams({section_id: this.dataset.section, product_id: id, limit: '3', intent: 'complementary'});
            const response = await fetch(url);
            if (!response.ok) continue;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            for (const card of doc.querySelectorAll('[data-complement-id]')) {
              if (seen.has(card.dataset.complementId) || list.children.length >= 3) continue;
              seen.add(card.dataset.complementId);
              list.append(document.importNode(card, true));
            }
          } catch { /* Keep the checkout usable when no complementary products are configured. */ }
        }
        result.hidden = list.children.length === 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["performance-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const setup = () => document.querySelectorAll('[data-performance-footer]').forEach(footer => {
      if (initialized.has(footer)) return;
      initialized.add(footer);
      const breakpoint = window.matchMedia('(min-width: 750px)');
      const update = () => footer.querySelectorAll('details').forEach(details => {
        details.open = breakpoint.matches;
        const summary = details.querySelector('summary');
        if (breakpoint.matches) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      });
      update();
      breakpoint.addEventListener('change', update);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();
})();
